<script>
    import {API_URL} from "../../../env";
    import AccountHeader from "../../components/account/AccountHeader.svelte";
    import AccountNav from "../../components/account/AccountNav.svelte";
    import checkLoginValidity from "../../lib/checkLoginValidity";
    import {push, replace} from "svelte-spa-router";
    import {userData} from "../../js/stores";
    import {addAlert} from "../../js/alert";

    window.scrollTo(0, 0);
    if ($userData === null) replace("/?m=prihlasit-sa")

    // const strong = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/g
    // const medium = /((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,}))/g

    let isSuccessful = false

    let data = {
        password: "",
        newPassword: "",
        repeatNewPassword: ""
    }

    let bad = {
        password: false,
        newPassword: false,
        repeatNewPassword: false,
        message: ""
    }

    /** Password strength */
    let newPasswordStrength = {
        text: "",
        progressBar: 0,
        progressBarColor: "#888888",
    }

    let newPasswordCheck = {
        tooShort: true,
        noLowerCase: true,
        noUpperCase: true,
        noNumber: true,
        noSpecialCharacter: true
    }

    function checkPassword() {
        let val = data.newPassword || "";
        let strength = 0;

        newPasswordCheck = {
            tooShort: true,
            noLowerCase: true,
            noUpperCase: true,
            noNumber: true,
            noSpecialCharacter: true
        }

        if(val !== "") {
            // If the password length is less than or equal to 8
            if (val.length >= 8) {
                newPasswordCheck.tooShort = false
                strength += 1
            }


            // If the password not contains any lowercase alphabet. or any number or any special character
            if (val.match(/[a-z]/)) {
                newPasswordCheck.noLowerCase = false
                strength += 1
            }

            // If the password not contains any uppercase alphabet. or any number or any special character
            if (val.match(/[A-Z]/)) {
                newPasswordCheck.noUpperCase = false
                strength += 1
            }

            // If the password not contains any number.
            if (val.match(/\d+/)) {
                newPasswordCheck.noNumber = false
                strength += 1
            }
            // If the password not contains any number.
            if (val.match(/[!,@#$%^&*?_~\-().]/)) {
                newPasswordCheck.noSpecialCharacter = false
                strength += 1
            }
        }
        calculateProgressBar(strength)
    }

    function calculateProgressBar(strength) {
        switch (strength) {
            case 1:
            case 2:
            case 3:
                newPasswordStrength = {
                    text: "Slabé",
                    progressBar: 33,
                    progressBarColor: "#C32518"
                }
                break
            case 4:
                newPasswordStrength = {
                    text: "Priemerné",
                    progressBar: 66,
                    progressBarColor: "#fcba03"
                }
                break
            case 5:
                newPasswordStrength = {
                    text: "Silné",
                    progressBar: 100,
                    progressBarColor: "#3FC948"
                }
                break
            default:
                newPasswordStrength = {
                    text: "",
                    progressBar: 0,
                    progressBarColor: "#888888"
                }
                break
        }
    }

    let isFetching = false
    async function handleChangePassword() {     // TODO
        if (isFetching) return;
        isFetching = true

        /* CHECK ****/
        let ret = false
        bad = {
            password: false,
            newPassword: false,
            repeatNewPassword: false,
            message: ""
        }

        if (data.repeatNewPassword !== data.newPassword) {
            ret = true
            bad.repeatNewPassword = true
            //bad.message = "Nové heslá sa nezhodujú."

            addAlert("danger", "Chyba", "Nové heslá sa nezhodujú.")
        }
        if (data.newPassword.length > 8 && data.newPassword === data.password) {
            ret = true
            bad.newPassword = true
            //bad.message = "Staré heslo a nové heslo sú zhodné."

            addAlert("danger", "Chyba", "Staré heslo a nové heslo sú zhodné.")
        }
        if (data.newPassword.length < 8) {
            ret = true
            bad.newPassword = true
            //bad.message = "Nové heslo je príliš krátke."

            addAlert("danger", "Chyba", "Heslo je príliš krátke.")
        }

        if (ret) {
            return isFetching = false
        }
        /************/

        let body = {
            password: data.password,
            newPassword: data.newPassword,
        }

        const res = await fetch(API_URL + '/users/changePassword', {
            method: 'PUT',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })

        if (res.status === 403) {
            isFetching = false

            const json = await res.json()

            if (json.msg === "Invalid password.") {
                //bad.message = "Zlé heslo."
                bad.password = true

                addAlert("danger", "Chyba", "Zlé heslo.")
            }
            else {
                addAlert("danger", "Chyba", "Heslo sa nepodarilo zmeniť.")
            }
            return
        }
        else if (!res.ok) {
            isFetching = false
            if (checkLoginValidity(res.status)) return await push("/?m=prihlasit-sa");
            addAlert("danger", "Chyba", "Niekde nastala chyba. Skúste to prosím znova.")
            return
        }
        isFetching = false
        isSuccessful = true
    }


</script>

<section class="container" id="account">

    <AccountHeader/>

    <div class="account">

        <AccountNav/>

        <div class="account-content">
            {#if !isSuccessful}
                <h2>ZMENA HESLA</h2>
                <p>Pokiaľ si potrebujete zmeniť heslo, môžete to urobiť tu. Na overenie nového hesla budete potrebovať prístup k e-mailu, ktorý bol použitý pri registrácii tohto účtu.</p>
                <div class="row">
                    <div class="col-lg-6 col-xl-8">
                        <div class="row">
                            <div class="col-sm-6 col-lg-12 col-xl-6 mb-4">
                                <div class="input-group">
                                    <label for="password">Súčasné heslo</label>
                                    <input id="password" type="password" placeholder="Súčasné heslo" bind:value={data.password} class:unfilled={bad.password}>
                                </div>
                            </div>
                            <div class="col-sm-6 col-lg-12 col-xl-6 mb-4">
                                <div class="input-group">
                                    <label for="newPassword">Nové heslo</label>
                                    <input id="newPassword" type="password" placeholder="Nové heslo" bind:value={data.newPassword} on:input={checkPassword} class:unfilled={bad.newPassword}>
                                </div>
                            </div>
                            <div class="col-sm-6 col-lg-12 col-xl-6 mb-4">
                                <div class="input-group">
                                    <label for="repeatNewPassword">Nové heslo znovu</label>
                                    <input id="repeatNewPassword" type="password" placeholder="Nové heslo znovu" bind:value={data.repeatNewPassword} class:unfilled={bad.repeatNewPassword}>
                                </div>
                                {#if bad.message}
                                    <p class="text-danger">{bad.message}</p>
                                {/if}
                            </div>
                            <div class="col-sm-6 col-lg-12 col-xl-6 mb-4 d-flex flex-column justify-content-center">
                                <div class="account-strength mt-sm-4 mt-lg-0 mt-xl-4">
                                    <span>SÍLA HESLA</span>
                                    <div class="strength-bar" style="--progress-width: {newPasswordStrength.progressBar}%; --progress-hex: {newPasswordStrength.progressBarColor};"></div>
                                    {#if newPasswordStrength.text}
                                        <p>{newPasswordStrength.text}</p>
                                    {/if}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-4">
                        <div class="account-password">
                            <span>SILNÉ HESLO OBSAHUJE</span>
                            <ul>
                                <li><i class="fas fa-fw fa-{newPasswordCheck.noLowerCase ? 'times' : 'check'} mr-1"></i>Aspoň jedno malé písmeno</li>
                                <li><i class="fas fa-fw fa-{newPasswordCheck.noUpperCase ? 'times' : 'check'} mr-1"></i>Aspoň jedno veľké písmeno</li>
                                <li><i class="fas fa-fw fa-{newPasswordCheck.noNumber ? 'times' : 'check'} mr-1"></i>Aspoň jednu číslicu (0-9)</li>
                                <li><i class="fas fa-fw fa-{newPasswordCheck.tooShort ? 'times' : 'check'} mr-1"></i>Minimálne 8 znakov</li>
                                <li><i class="fas fa-fw fa-{newPasswordCheck.noSpecialCharacter ? 'times' : 'check'} mr-1"></i>Špeciálny znak</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row mt-4 mt-lg-0">
                    <div class="col-12 d-flex justify-content-end">
                        <button type="button" class="btn btn-primary btn-responsive" on:click={handleChangePassword}>
                            {#if isFetching}
                                <i class="fas fa-fw fa-spinner-third fa-spin mr-2"></i>
                            {:else}
                                <i class="fas fa-fw fa-user-lock mr-2"></i>
                            {/if}
                            Zmeniť heslo
                        </button>
                    </div>
                </div>
            {:else}
                <div class="loading-page">
                    <i class="far fa-fw fa-circle-check"></i>
                    <h3>Heslo bolo úspešne zmenené.</h3>
                </div>
            {/if}
        </div>
    </div>
</section>